import React from 'react';
import { Card, CardContent, CardMedia, Link, Box, Typography } from '@mui/material';
import cx from 'classnames';
import { DEFAULT_IMAGE } from '../../utils/transformers';
import Styles from './ZoneCard.module.scss';
import type { ZoneCardData } from '../../types/cards';
import CloudflareResizedImage from '../CloudflareResizedImage';

type Props = {
  data: ZoneCardData;
  trackCardClick?: () => void;
};

const ZoneCard: React.FC<Props> = ({ data, trackCardClick }) => {
  const { src, link, title, subtitle, caption } = data;
  return (
    <Link className={Styles.zoneCardLink} href={link} key={link}>
      <Card className={Styles.zoneCardWrap} onClick={trackCardClick}>
        <div className={Styles.zoneCardMediaWrap}>
          <CardMedia className={Styles.zoneCardMedia}>
            <CloudflareResizedImage
              src={src || DEFAULT_IMAGE}
              alt={`${title} surf zone`}
              width={150}
              height={150}
              quality={100}
              loading="lazy"
              layout="intrinsic"
              objectFit="cover"
              objectPosition="center"
            />
          </CardMedia>
        </div>
        <Box className={Styles.zoneCardContentWrap}>
          <CardContent className={Styles.zoneCardContent}>
            <Typography
              variant="subHeadline"
              component="h3"
              className={cx(Styles.zoneCardText, Styles.zoneCardHeadline)}
            >
              {title}
            </Typography>
            <Typography
              variant="callout2"
              component="p"
              className={cx(Styles.zoneCardText, Styles.zoneCardTextZone)}
            >
              {subtitle}
            </Typography>
            <Typography
              variant="callout2"
              component="p"
              className={cx(Styles.zoneCardText, Styles.zoneCardSpotCount)}
            >
              {caption}
            </Typography>
          </CardContent>
        </Box>
      </Card>
    </Link>
  );
};

export default ZoneCard;
